import type { NavigationGuard, RouteConfig, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}

export const RegisterRoutes: RouteConfig[] = [
	{
		path: `/register`,
		component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/master.vue').then((m) => m.default),
		children: [
			{ path: `terms-conditions`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/terms-conditions.vue').then((m) => m.default), },
			{ path: `your-details`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/your-details.vue').then((m) => m.default), },
			{ path: `check-details`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/check-details.vue').then((m) => m.default), beforeEnter: multiGuard([loadNavigationGuard('RequiresUserDetails'), loadNavigationGuard('RequiresUserRegisterDetails'),]), },
			{ path: `set-login-details`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/set-login-details.vue').then((m) => m.default), beforeEnter: multiGuard([loadNavigationGuard('RequiresUserDetails'), loadNavigationGuard('RequiresUserRegisterDetails'),]), },
			{ path: `verification`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/email-verification.vue').then((m) => m.default), beforeEnter: multiGuard([loadNavigationGuard('RequiresUserDetails'), loadNavigationGuard('RequiresUserRegisterDetails'),]), },
			{ path: `success`, name: `RegistrationSuccess`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/registration-success.vue').then((m) => m.default), },
			{ path: `link-expired`, name: `RegistrationLinkExpired`, component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/link-expired.vue').then((m) => m.default), },
			{ path: '', component: () => import(/* webpackChunkName: "chunk-your-account-register" */'./pages/index.vue').then((m) => m.default), name: 'Register', },
		],
	},
];
